import React, { useState } from "react";
import { Form, Collapse } from "antd";
import TourAccommodationForm from "../../pages/EditForm/TourAccommodationForm";

const { Panel } = Collapse;

interface TourAccommodationSectionProps {
    form: any;
    initialValues?: any;
    tiaData?: any;
    jwtToken?: any;
    recordId?: any;
}

const config = {
    rules: [
        {
            required: true,
            message: "此項為必填。",
        },
    ],
};

export default function TourAccommodationSection({ 
    form, 
    initialValues, 
    tiaData,
    jwtToken,
    recordId 
}: TourAccommodationSectionProps) {
    const [roomInfoRequired, setRoomInfoRequired] = useState(false);
    const [fileList, setFileList] = useState<any[]>([]);

    const accommodationTypeList = tiaData?.typeOfAccommdation || ["內地旅行代理商", "香港持牌旅行代理商", "旅客自行處理"];

    return (
        <Collapse defaultActiveKey={["1"]}>
            <Panel header={<h3>第 V 部分：負責預訂住宿, 房間供應商及房間資料</h3>} key="1" forceRender>
                <Form
                    form={form}
                    layout="vertical"
                    initialValues={initialValues}
                >
                    <TourAccommodationForm
                        form={form}
                        config={config}
                        accommodationTypeList={accommodationTypeList}
                        roomInfoRequired={roomInfoRequired}
                        setRoomInfoRequired={setRoomInfoRequired}
                        fileList={fileList}
                        setFileList={setFileList}
                        jwtToken={jwtToken}
                        recordId={recordId}
                    />
                </Form>
            </Panel>
        </Collapse>
    );
}
